module.exports = __webpack_public_path__ + "static/Icon2-035a0f6f151135fb4c66883e2157154b.png";